import { Injectable } from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { UserRegistration } from '../../shared/models/user.registration.interface';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { BaseService } from '../../shared/services/base.service';
import { UserManagerService } from '../../shared/services/user-manager.service';
import { UserVM } from 'src/app/shared/models/VM/user-vm';
import { PagingData } from 'src/app/shared/models/Com/PagingData';





@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {


  baseUrl: string = '';
  logedIn: boolean = false;
  users: UserVM[];
  constructor(private configService: ConfigService, private httRequest: HttpRequestService) {

    super();
    this.baseUrl = configService.getApiURI();
  }

  // addUser(username: string, email: string, password: string, firstName: string, lastName: string, location: string, roleName, userId: string, active: boolean)
  // {
  //   let body = { username, email, password, firstName, lastName, location, roleName, userId, active };
  //   return this.httRequest.postRequest('accounts', body).pipe(map((res: any) => res), catchError(err => { console.error(err); return throwError(err) }));
  // }

  addUser(email: string,username: string, phonenumber:string, password: string , roleName, userId: string)
  {
    let body = {  email, username,phonenumber, password, roleName, userId};
    return this.httRequest.postRequest('accounts', body).pipe(map((res: any) => res), catchError(err => { console.error(err); return throwError(err) }));
  }

  isUserExist(value: string) {
    //  alert(value);
    return this.httRequest.GetRequest('user/isUserExist/' + value).toPromise();
  }
  ActiveChange(id: string, checked: boolean) {
    return this.httRequest.GetRequest('user/ActiveChange/' + id + '/' + checked).toPromise();
  }
  getUsers(pagingData: PagingData) {
    return this.httRequest.GetRequest('user/getUsers/' + pagingData.page + '/' + pagingData.pageCount).toPromise();
  }
  getAllUsers(page,pageSize) {
    return this.httRequest.GetRequest('user/getUsers/' + page + '/' + pageSize)
  }
  SearchUsers(name, page, pageSize) {
    // alert(name)

    // name = name.replace(/[^a-zA-Zء-ي0-9]/g, " ");
     return this.httRequest.GetRequest('user/SearchUsers/' + name + '/' + page + '/' + pageSize)
   }
  search(page,pageSize,keyWord) {
    return this.httRequest.GetRequest('user/Search/'+ keyWord +'/' + page + '/' + pageSize  )
  }

  updateActiveStatus(email: string, isActive: boolean){
   
    return this.httRequest.GetRequest('user/UpdateUserActiveStatus/'+email+'/'+isActive)
  }

  login(userName, password) {
// alert('login')
// alert('login')
    return this.httRequest.postRequest
      (
        'auth/login',
        { userName, password }
      ).pipe(map((res: any) => res), catchError(err => { console.error(err); return err; }));
  }

  getRoles() {
    return this.httRequest.GetRequest('role').toPromise();
  }
  getById(id) {
    return this.httRequest.GetRequest('user/GetUserById/' + id).toPromise();
  }
  deleteAccount(userDetails) {
    return this.httRequest.postRequest('Patients/deleteAcc' , userDetails)
  }
}
